import { useQuery } from '@tanstack/react-query';
import IntegrationSettingsService from '../services/integrationSettingsService';
import { IntegrationSettings } from '../models/integrationSettings';
import { IntegrationType } from '../models/waterfall';

export const useIntegrationSettingsByType = (integrationType?: IntegrationType) => {
  const isEnabled = !!integrationType && integrationType !== IntegrationType.None;

  return useQuery<IntegrationSettings[]>({
    queryKey: ['integration-settings-by-type', integrationType],
    queryFn: () => IntegrationSettingsService.getInstance().getByType(integrationType as IntegrationType),
    enabled: isEnabled,
    staleTime: 30_000,
  });
};
